module.exports = __webpack_public_path__ + "img/weary.9422c8c1.png";